import axios from "axios";
import { useState, useEffect } from "react";
import { MetaPorOutrasFamilias } from "types/sales";
import { springPage } from "types/vendor/springPage";
import { isAuthenticated, getTokenData } from "utils/auth";
import { BASE_URL } from "utils/request";
import { getAuthData } from "utils/storage";
import { formatPrice } from "utils/format";

const OutrosMeta = () => {

    const [metaOutros, setMetaOutros] = useState<springPage<MetaPorOutrasFamilias>>();

    useEffect(() => {
        if (isAuthenticated()) {
            axios.get(`${BASE_URL}/metas/metas-por-familia?rota=${getTokenData()?.user_name}`,
                { headers: { Authorization: "Bearer " + getAuthData().access_token } })
                .then((response) => {
                    setMetaOutros(response.data);
                })
        };
    }, []);
    return (

        <div className=" d-flex flex-wrap justify-content-center">
            {metaOutros?.content.map(item =>
                <div  key = {item.valor} className="card-body">
                    <div className="card text-primary"><span className="card-header text-white mb-1 text-primary">{item.familia}</span>
                        <span className="dropdown-item-text">Meta mensal <h5 className="text-secondary">{formatPrice(item.valor)}</h5></span>
                        <span className="dropdown-item-text">Meta diária <h5 className="text-secondary">{formatPrice(item.valor / 26)}</h5></span>
                    </div>
                </div>
            )
            }
        </div>
    )
}
export default OutrosMeta;

